// ggmenu state
export const getGGMenuState = state => state.ggmenu

